
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 2.123c1.07 0 2.04.434 2.741 1.136A3.866 3.866 0 019.877 6c0 1.07-.434 2.04-1.136 2.741A3.866 3.866 0 016 9.877c-1.07 0-2.04-.434-2.741-1.136A3.866 3.866 0 012.123 6c0-1.07.434-2.04 1.136-2.741A3.866 3.866 0 016 2.123zM6 0c1.657 0 3.157.672 4.242 1.758A5.981 5.981 0 0112 6a5.978 5.978 0 01-1.758 4.242A5.981 5.981 0 016 12a5.978 5.978 0 01-4.242-1.758A5.978 5.978 0 010 6c0-1.657.672-3.157 1.758-4.242A5.978 5.978 0 016 0zm3.128 2.872A4.409 4.409 0 006 1.576a4.409 4.409 0 00-3.128 1.296c-.8.8-1.296 1.906-1.296 3.128 0 1.222.495 2.327 1.296 3.128.8.8 1.906 1.296 3.128 1.296a4.409 4.409 0 003.128-1.296c.8-.8 1.296-1.906 1.296-3.128a4.409 4.409 0 00-1.296-3.128zM6.392 5.544A.55.55 0 006 5.383a.552.552 0 00-.392.16v.002a.55.55 0 00-.162.392c0 .153.062.292.161.391l.001.001c.1.1.238.161.392.161a.552.552 0 00.392-.16v-.002c.1-.1.162-.238.162-.391a.56.56 0 00-.162-.393zm-.038-.584a1.05 1.05 0 01.48.36l.01-.004 2.052-.55a3.138 3.138 0 00-.671-.993 3.138 3.138 0 00-1.872-.902v2.063a.08.08 0 010 .026zm.681 1.059a1.033 1.033 0 01-.153.464l.013.02L8.073 8.37a3.14 3.14 0 001.03-2.906l-2.068.554zm-.73.91a1.02 1.02 0 01-.582.008l-1.15 1.87c.428.22.913.342 1.427.342.533 0 1.035-.132 1.476-.366L6.306 6.93zm-1.171-.421a1.02 1.02 0 01-.166-.46h-.001l-2.06-.645a3.14 3.14 0 001.059 3.001L5.118 6.53a.183.183 0 00.016-.022zm.014-1.164a1.056 1.056 0 01.48-.376.377.377 0 01-.001-.033V2.874a3.162 3.162 0 00-2.501 1.838l2.022.632z"}})])
          )
        }
      }
    